import type { IconNode } from '../types';

/**
 * @name bottle-champagne
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAyaC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgM2guMDEiIC8+CiAgPHBhdGggZD0ibTE5IDgtMy0zIiAvPgogIDxwYXRoIGQ9Ik05LjcgMjEuM2EyLjQgMi40IDAgMCAxLTMuNCAwbC0zLjYtMy42YTIuNDEgMi40MSAwIDAgMSAwLTMuNGw2LjI3LTYuMjdBMy41IDMuNSAwIDAgMSAxMS40NSA3aDEuMWEzLjUgMy41IDAgMCAwIDIuNDctMS4wM2wzLjYyLTMuNjFhMS4yMSAxLjIxIDAgMCAxIDEuNzIgMGwxLjI4IDEuMjhhMS4yIDEuMiAwIDAgMSAwIDEuNzJsLTMuNjIgMy42MUEzLjUgMy41IDAgMCAwIDE3IDExLjQ1djEuMWEzLjUgMy41IDAgMCAxLTEuMDMgMi40OFoiIC8+CiAgPHBhdGggZD0ibTkuMDYgOCAzLjIzIDMuMjRhMSAxIDAgMCAxIDAgMS40MUw4LjY1IDE2LjNhMSAxIDAgMCAxLTEuNDEgMEw0IDEzLjA2IiAvPgogIDxwYXRoIGQ9Ik0yMSAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTIyIDE2aC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/bottle-champagne
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottleChampagne: IconNode = [
  ['path', { d: 'M8 2h.01', key: 'l986my' }],
  ['path', { d: 'M12 3h.01', key: 'n36tog' }],
  ['path', { d: 'm19 8-3-3', key: '4lll47' }],
  [
    'path',
    {
      d: 'M9.7 21.3a2.4 2.4 0 0 1-3.4 0l-3.6-3.6a2.41 2.41 0 0 1 0-3.4l6.27-6.27A3.5 3.5 0 0 1 11.45 7h1.1a3.5 3.5 0 0 0 2.47-1.03l3.62-3.61a1.21 1.21 0 0 1 1.72 0l1.28 1.28a1.2 1.2 0 0 1 0 1.72l-3.62 3.61A3.5 3.5 0 0 0 17 11.45v1.1a3.5 3.5 0 0 1-1.03 2.48Z',
      key: '114cy7',
    },
  ],
  [
    'path',
    { d: 'm9.06 8 3.23 3.24a1 1 0 0 1 0 1.41L8.65 16.3a1 1 0 0 1-1.41 0L4 13.06', key: '3mtip1' },
  ],
  ['path', { d: 'M21 12h.01', key: 'msek7k' }],
  ['path', { d: 'M22 16h.01', key: '1ghu17' }],
];

export default bottleChampagne;
